import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Alert } from '@mui/material';
import { styled } from '@mui/material/styles';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    pointerEvents: 'auto',
  },
}));

const SessionExpiredModal = ({ open, onNavigateToLogin }) => {
  return (
    <BootstrapDialog
      open={open}
      aria-labelledby='session-expired-dialog-title'
      disableEscapeKeyDown
      onClose={(event, reason) => {
        // Prevent closing on backdrop click or escape key
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
      }}
      BackdropProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backdropFilter: 'blur(5px)',
          opacity: 0.7,
        },
      }}
    >
      <DialogTitle
        id='session-expired-dialog-title'
        style={{ fontSize: '16px' }}
        className='customized-dialog-title'
      >
        Session Expired
      </DialogTitle>

      <DialogContent>
        <Alert severity='error' className='f-13-5 mt-8 mb-8 fw-400' style={{ lineHeight: '1.5' }}>
          Your session has expired. Please log in again to continue.
        </Alert>
      </DialogContent>
      <DialogActions className='mt-8'>
        <Button
          autoFocus
          onClick={onNavigateToLogin}
          variant='contained'
          color='primary'
          className='p-2'
          fullWidth
        >
          Go to Login
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default SessionExpiredModal;
